export const schemaUtils = {
  emailRegExp:
    /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2,8})?)$/i,
  phoneRegExp: /^\(\d{3}\) \d{3}-\d{4}$/,
  pawdRegExp: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
  phoneRegex:
    /^([+]?\d{10}|[+]?\d{3}\.\d{3}\.\d{4}|[+]?\d{3}-\d{3}-\d{4}|[+]?\d{3}\s\d{3}\s\d{4}|[+]?\(\d{3}\)\s\d{3}-\d{4}|[+]?\(\d{3}\)\d{3}-\d{4}|[+]?\(\d{3}\)\(\d{3}\)\(\d{4}\)|[+]?\(\d{3}\)\(\d{3}\)\d{4}|[+]?\(\d{3}\)\d{7}|[+]?\(\d{3}\)\d{3}\s\d{4}|[+]?\(\d{3}\)\s\d{3}\s\d{4})$/,
};
